/* eslint-disable no-loop-func */
import React, { Fragment, useEffect, useState } from 'react';
import Button from '../components/ui/Button';
import { Progress, Spin } from 'antd';
import Encuesta from '../components/PollView';
import poweredBySmile from '../assets/powered-by-smile.png';
import poweredBySmileWhite from '../assets/powered-by-smile-blanco.png';
import Metadata from '../components/Metadata';
import Presentation from '../components/Presentation';
import Links from '../components/Links';
import UserDataFields from '../components/UserDataFields';
import CommentFields from '../components/CommentFields';
import UserDataForm from '../components/UserDataForm';
import Arrows from '../components/Arrows';
import Smilehelper from '../utils/Smilehelper';
import { getOneOf } from '../utils/objects';
import get from 'lodash/get';
import { useStoreContext } from '../context/store';
import { useHistory, useLocation } from 'react-router-dom';
import { enabled, log } from '../utils/debug';
import { useI18n } from '../utils/i18n';
import { useTranslation } from 'react-i18next';
import { useMergeableState } from '../utils/hooks';
import { useFormData } from '../hooks/form';
import { parse } from 'query-string';
import merge from 'lodash/merge';

const allTrue = (values, initial = true) =>
  values.reduce(
    (ret, value) =>
      ret && (Array.isArray(value) ? allTrue(value, initial) : value),
    true
  );

const storeVariables = ['name'];
const contactVariables = ['first_name', 'last_name'];
const QuestionsStep = ({ currentStep, ...props }) => {
  return (
    <Fragment>
      <Encuesta
        {...{
          questions: currentStep.questions,
        }}
        {...props}
      />
    </Fragment>
  );
};

const Form = ({ data }) => {
  const formData = useFormData(data);
  const { context, dispatch } = useStoreContext();
  const location = useLocation();
  const history = useHistory();
  const [feedbackId, setFeedbackId] = useState(undefined);

  const [isFinishing, setIsFinishing] = useState(false);
  const t = useI18n();
  const { userData, answers, questionsValid } = context;
  const { i18n } = useTranslation();

  const [busy, setBusy] = useState(false);

  const {
    poll: encuesta,
    device,
    campaign,
    theme,
    store,
    links = [],
    contact,
    usuario_final_id,
  } = context.data;

  const { hash } = context.state;

  const { atLastPage, working } = context.ui;

  const [state, setState] = useMergeableState({});
  const [resultado, setResultado] = useState([]);

  const setUserData = (payload) => {
    dispatch({
      type: 'userData.update',
      payload,
    });
  };

  useEffect(() => {
    if (!encuesta) return;
    if (!encuesta.language) {
      i18n.changeLanguage('es');
      return;
    }
    i18n.changeLanguage(encuesta.language);
  }, [encuesta, i18n]);


  useEffect(()=>{
    const lang = localStorage.getItem('i18nextLng');
    const element = document.getElementsByTagName("html");
    element[0].setAttribute('lang',lang);
  },[localStorage.getItem('i18nextLng')]);

  const [dataToSend, setDataToSend] = useState(undefined);

  const isIframe = hash ? hash.includes('iframe') : null;

  let isDark = context.ui.isDark;
  let poweredBySmileSrc = isDark ? poweredBySmileWhite : poweredBySmile;

  const showPoweredBySmile = get(encuesta, 'settings.showPoweredBySmile', true);

  const [steps, setSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(undefined);

  function updateResultado(value) {
    value.forEach((entry, i) => {
      let error = false;
      if (
        get(encuesta, `preguntas.${i}.type`) !== 'thanks' &&
        get(value[i], 'dirty')
      )
        error = !encuesta.preguntas[i].isResponseValid(answers);
      value[i] = {
        ...entry,
        error: error,
      };
    });
    setResultado([...value]);
    dispatch({
      type: 'answers.update',
      payload: [...value],
    });
  }

  useEffect(() => {
    // Build Resultado
    if (!encuesta) return;

    // Resultado
    const resultado = [];
    const query = parse(location.search);
    encuesta.preguntas.forEach((pregunta, i) => {
      const value = get(query, 'v');
      const min = pregunta.min;
      const max = pregunta.max;
      const setValue =
        value &&
        i === 0 &&
        pregunta.score_type !== null &&
        parseInt(value) >= min &&
        parseInt(value) <= max;
      let score = 0;
      if (setValue) score = ((parseInt(value) - min) * 9) / (max - min) + 1;
      if (get(pregunta, 'type', 'question') === 'thanks') return;
      resultado.push({
        voto: setValue
          ? parseInt(value)
          : pregunta.score_type === 'smiles'
          ? undefined
          : 0,
        score: setValue ? score : undefined,
        error: undefined,
        pregunta: pregunta.id, // Deprecate
        questionId: pregunta.id,
        motivoSelected:
          get(pregunta, 'motives', []).length >= 2 ||
          get(pregunta, 'motives', []).length < 1
            ? []
            : [pregunta.motives[0].id],
        dirty: setValue ? true : false,
      });
    });
    updateResultado(resultado);
  }, [encuesta]);

  useEffect(() => {
    // Build Steps
    const steps = [];

    if (get(encuesta, 'settings.presentation', false)) {
      steps.push({ type: 'presentation' });
    }

    const formStep =
      get(campaign, 'metadata.form.enabled', true) &&
      get(campaign, 'metadata.form.fields', []).length
        ? {
            type: 'form',
            done: ({ context }) => {
              const required = context.userContactData.filter(
                (filter) => filter.required === true
              );
              const invalidResponses = required.reduce(
                (ret, entry) =>
                  ret +
                  (entry.response === undefined || entry.response === ''
                    ? 1
                    : 0),
                0
              );
              return invalidResponses === 0 ? true : false;
            },
          }
        : undefined;

    if (
      formStep &&
      get(campaign, 'metadata.form.location', 'start') === 'start'
    ) {
      steps.push(formStep);
    }

    if (get(encuesta, 'settings.userVisitFields')) {
      steps.push({
        type: 'metadata',
        autoStep: true,
        done: ({ userData }) => userData.is_first_visit !== undefined,
      });
      steps.push({
        type: 'metadata',
        autoStep: true,
        done: ({ userData }) => userData.referral !== undefined,
      });
    }

    const sortedQuestions = get(encuesta, 'sortedQuestions', []);

    //pusheo una pregunta vacia para que quede en el que sigue el comment fields

    // if (false && isIframe && (encuesta.settings.commentsFields || encuesta.settings.userDataFields)) {
    //   sortedQuestions.push([]);
    // }

    if (sortedQuestions.length > 0) {
      steps.push({
        type: 'questions',
        questions: sortedQuestions,
        isLastStep: true,
        done: ({ answers }) => {
          // if (isLastStep) return false;
          const valid = sortedQuestions.map((entry) => {
            return entry.getErrors(answers).length === 0;
          });

          return allTrue(valid);
        },
      });
    }

    if (
      formStep &&
      get(campaign, 'metadata.form.location', 'start') === 'end'
    ) {
      steps.push(formStep);
    }
    setSteps(steps);
  }, [encuesta, campaign]);

  useEffect(() => {
    if (!dataToSend) return;
    const query = parse(location.search);
    const autoSave =
      get(query, 'v') &&
      get(campaign, 'metadata.settings.auto-save-first-question')&&
      contact;
    const payload = {
      ...dataToSend,
      store_key: get(context, 'data.store.key'),
      hash,
      deviceType: device.deviceType,
      url_from: get(context, 'data.url_from.url_from')
    };
    (async () => {
      setBusy(true);
      try {
        if (
          get(context, 'session.requestDone') &&
          !['playground'].includes(hash)
        ) {
          if (autoSave && isFinishing)
            await Smilehelper.updateFeedback({
              ...payload,
              feedbackId: feedbackId,
            });
          if (isFinishing && !autoSave) await Smilehelper.postDatos(payload);
          if (autoSave && !isFinishing) {
            const response = await Smilehelper.postDatos(payload);
            setFeedbackId(response.id);
          }
        }
        if (!isFinishing) return;
        setState({
          formSent: true,
        });

        history.push({
          ...location,
          pathname: hash ? `/${hash}/thanks` : '/thanks',
        });

        // Clear things
        await dispatch({
          type: 'answers.clear',
        });
        await dispatch({
          type: 'ui.clear',
        });
        await dispatch({
          type: 'userContactData.clear',
        });
        await dispatch({
          type: 'data.update',
          payload: {
            showErrors: false,
          },
        });
      } catch (err) {
        console.error(err);
      } finally {
        setBusy(false);
      }
    })();
  }, [dataToSend]);

  useEffect(() => {
    if (!currentStep) return;
    if (currentStep.type !== 'presentation') return;
    if (document.getElementById(currentStep.type) == null) return;
    setTimeout(() => {
      let str = document.getElementById(currentStep.type);
      let inner = get(str, 'innerHTML');
      if (!inner) return;
      storeVariables.forEach((variable) => {
        inner = inner
          .split(`{{ store.${variable} }}`)
          .join(get(store, variable, null) != null ? store[variable] : '');
      });
      contactVariables.forEach((variable) => {
        inner = inner
          .split(`{{ contact.${variable} }}`)
          .join(get(contact, variable, null) != null ? contact[variable] : '');
      });

      str.innerHTML = inner;
    }, 1);
  });

  async function makePayload(firstVote) {
    if (!firstVote) {
      dispatch({
        type: 'data.update',
        payload: {
          showErrors: true,
        },
      });

      if (!validateAll()) return;
    }

    const data = {
      userContext: context.data.userContext,
      form: merge(
        {
          contact: {
            external_id: context.data.contact.external_id,
          },
        },
        {
          ...context.userContactData.reduce((reduced, field) => {
            const target = field.target || 'campaign';
            reduced[target] = reduced[target] || {};
            if (field.custom || field.target === 'campaign')
              reduced[target].custom_data = reduced[target].custom_data || {};

            Object.assign(
              field.custom ? reduced[target].custom_data : reduced[target],
              {
                [field.name]: (() => {
                  if (field.response && field.response.toDate) {
                    return field.response.format();
                  }
                  return field.response;
                })(),
              }
            );

            return reduced;
          }, {}),
        }
      ),
    };

    // VALIDO LAS RESPUESTAS QUE ESTAN EN EL CAMINO

    // Validate Poll Questions

    if (get(encuesta, 'preguntas', []).length) {
      const dataAnswers = [];

      const answerInQuestions = (answer) => {
        return questionsValid.find((question) => {
          return question.matchId(answer.questionId);
        });
      };

      const answersValid = answers.filter((answer) =>
        answerInQuestions(answer)
      );

      if(firstVote && answersValid.length>0){
        const dato = answersValid[0];
        data.answers = [
          {
            encuesta: encuesta.id,
            pregunta: dato.pregunta,
            v: dato.voto,
            score: dato.score,
            ...userData,
            comment: dato.comment,
            b: device ? device.id : undefined,
            usuario_final_id,
          }
        ];
        return data;
      }

      answersValid.forEach((dato, index) => {
        let question = questionsValid.find((question) => {
          return question.matchId(dato.questionId);
        });
        if (get(question, 'questions')) {
          question = get(question, 'questions', []).find(
            (questionMatrix) => questionMatrix.id === dato.questionId
          );
        }
        if (question.type === 'question' && !dato.score && question.score_type !== null) return;
        if(dato.motivoSelected.length === 0) {
          let payload = {};
          if(question.type === 'question' ){
            payload = {
              encuesta: encuesta.id,
              pregunta: dato.pregunta,
              v: dato.voto,
              score: dato.score,
              ...userData,
              comment: dato.comment,
              b: device ? device.id : undefined,
              usuario_final_id,
            }
          }
          if(question.type === 'information'){
            payload = {
              pregunta: dato.pregunta
            }
          }
          if(question.type === 'attachment'){
            payload = {
              pregunta: question.id,
              src: dato.src
            }
          }
          dataAnswers.push(payload);
          return;
        }
        dato.motivoSelected.forEach((motivo) => {
          const entry = {
            encuesta: encuesta.id,
            motivo,
            pregunta: dato.pregunta,
            v: dato.voto,
            score: dato.score,
            ...userData,
            comment: dato.comment,
            b: device ? device.id : undefined,
            usuario_final_id,
          };

          dataAnswers.push(entry);
        });
      });

      data.answers = dataAnswers;
    }

    return data;
  }

  useEffect(() => {
    const query = parse(location.search);
    if(feedbackId) return;
    if((!get(query, 'v')) || answers.length === 0) return;
    (async()=>{
      if (!(get(campaign, 'metadata.settings.auto-save-first-question') && contact))return;
      const data = await makePayload(true);
      if(get(data,'answers',[]).length ===0) return;
      if (enabled()) {
        log('dataToSend', data);
      } else {
        setDataToSend(data);
        dispatch({
          type: 'update',
          path: 'data.dataToSend',
          payload: data,
        });
      }
    })();

  }, [answers, campaign, contact]);

  async function prepareDataToSend() {
    const query = parse(location.search);
    if (
      dataToSend &&
      !(get(query, 'v') &&
        get(campaign, 'metadata.settings.auto-save-first-question') &&
        contact
      )
    )
      return;
    const data = await makePayload();

    if (enabled()) {
      log('dataToSend', data);
    } else {
      setIsFinishing(true);
      setDataToSend(data);
      dispatch({
        type: 'update',
        path: 'data.dataToSend',
        payload: data,
      });
    }
  }

  function onChangePregunta(payload, index) {
    if (answers[index].dirty === false) {
      dispatch({
        type: 'ui.update',
        payload: {
          freezeAutoStep: false,
        },
      });
    }

    answers[index] = {
      ...payload,
      dirty: true,
    };

    updateResultado(answers);
  }

  const validateAll = () => {
    // VALIDATE CONTACTDATA IS COMPLETE FOR REQUIRED FIELDS
    const requiredContactData = get(campaign, 'metadata.form.enabled', true)
      ? context.userContactData.filter((filter) => filter.required === true)
      : [];
    const invalidResponsesContactData = requiredContactData.reduce(
      (ret, entry) =>
        ret + (entry.response === undefined || entry.response === '' ? 1 : 0),
      0
    );

    // VALIDATE POLL QUESTIONS
    let errorsInForm = undefined;
    if (get(encuesta, 'preguntas', []).length) {
      errorsInForm = questionsValid.reduce((reduced, item) => {
        return [...reduced, ...item.getErrors(answers)];
      }, []);
    }

    // Validate User Data

    const requiredDataFields = get(
      encuesta,
      'metadata.settings.requiredDataFields',
      []
    );

    let invalidUserDataResponse = false;

    Object.keys(userData).forEach((key, index) => {
      if (userData[key] !== undefined) {
        if (userData[key].length === 0 && requiredDataFields.includes(key)) {
          invalidUserDataResponse = true;
        }
      }
    });

    if(get(userData, 'emailValidation', true) === false) {
      invalidUserDataResponse = true;
    }

    if (
      invalidResponsesContactData > 0 ||
      (errorsInForm && errorsInForm.length) ||
      invalidUserDataResponse
    ) {
      return false;
    }

    return true;
  };

  const hasProgressBar = get(encuesta, 'settings.showProgressBar', false);

  const progressForm = () => {
    const answerInQuestions = (answer) => {
      return questionsValid.find((question) => {
        return question.matchId(answer.questionId);
      });
    };

    const answersValid = answers.filter((answer) => answerInQuestions(answer));
    const validResponses = answersValid.reduce(
      (ret, entry) =>
        ret + (entry.error === false && entry.visited === true ? 1 : 0),
      0
    );

    let calc = Math.round((validResponses / encuesta.preguntas.length) * 100);

    if (validResponses === answersValid.length && atLastPage) {
      calc = 100;
    }
    return calc;
  };

  // header and footer
  const header =
    get(theme, 'header') ||
    getOneOf([campaign, device, encuesta], 'metadata.settings.header');
  const footer =
    get(theme, 'footer') ||
    getOneOf([campaign, device, encuesta], 'metadata.settings.footer');

  const progressBarColor =
    get(theme, '--progressBar-color') ||
    getOneOf(
      [campaign, device, encuesta],
      'metadata.theme.--progressBar-color'
    );
  const showLogo = get(encuesta, 'metadata.settings.showLogo', true);

  // send button
  const sendButtonType = get(theme, '--buttonType', 'default');

  if (!formData) {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin data-testid="spinner" />
      </div>
    );
  }

  return (
    <div className="container">
      {(!currentStep ||
        (currentStep && currentStep.type !== 'thanks' && !isIframe)) && (
        <div className={'principal'}>
          {get(campaign, 'src') && showLogo && !header ? (
            <div style={{ marginTop: '15px' }} className={'pregunta'}>
              <img alt="logo" className={'imagen'} src={campaign.src} />
            </div>
          ) : null}

          {header && (
            <div style={{ width: '100%' }}>
              <img
                style={{ width: '100%', marginBottom: '10px' }}
                src={header}
              />
            </div>
          )}
        </div>
      )}
      {campaign && campaign.type === 'link' && (
        <Links links={links} campaign={campaign} />
      )}
      {currentStep && (
        <div
          className="inside"
          // style={{
          //   flexGrow: 1,
          // }}
        >
          {currentStep.type === 'presentation' && (
            <Presentation />
          )}
          {currentStep.type === 'form' && <UserDataForm campaign={campaign} />}
          {currentStep.type === 'metadata' && (
            <Metadata
              encuesta={encuesta}
              updateReferral={(referral) => setUserData({ referral })}
              updateVisit={(i) => setUserData({ is_first_visit: i === 1 })}
            />
          )}
          {currentStep.type === 'questions' && (
            <div>
              <div>
                <QuestionsStep
                  {...{
                    deviceType: device.deviceType,
                    answers,
                    currentStep,
                    onChangePregunta,
                  }}
                />
              </div>
            </div>
          )}
          {atLastPage && currentStep.type === 'questions' && (
            <div>
              {' '}
              {encuesta.settings.commentsFields && (
                <CommentFields encuesta={encuesta} setUserData={setUserData} />
              )}
              {encuesta.settings.userDataFields && (
                <UserDataFields
                  encuesta={encuesta}
                  setUserData={setUserData}
                  userData={userData}
                />
              )}
            </div>
          )}
        </div>
      )}
      <div className="footer">
        <Arrows
          steps={steps}
          onStepChange={setCurrentStep}
          renderSendButton={() =>
            sendButtonType === 'default' ? (
              <Button
                disabled={busy || working}
                testid="send-button"
                style={
                  !validateAll() || busy || working
                    ? { backgroundColor: '#8a8a8a', color: 'white' }
                    : null
                }
                className={'boton'}
                onClick={() => prepareDataToSend()}
              >
                {t('send')}
              </Button>
            ) : (
              <Button
                disabled={busy}
                pill
                theme="secondary"
                testid="send-button"
                className="shadowed"
                size="sm"
                style={
                  !validateAll() || busy
                    ? { backgroundColor: '#8a8a8a', color: 'white' }
                    : null
                }
                // className={'boton'}
                onClick={() => prepareDataToSend()}
              >
                {t('send')}
                <img
                  style={{ width: '16px' }}
                  src={
                    'https://www.flaticon.com/svg/static/icons/svg/736/736212.svg'
                  }
                />
              </Button>
            )
          }
        />

        {hasProgressBar &&
          encuesta &&
          currentStep &&
          currentStep.type === 'questions' && (
            <Progress
              style={{ width: '90%', alignSelf: 'center' }}
              percent={progressForm()}
              status="active"
              showInfo={false}
              strokeColor={progressBarColor ? progressBarColor : '#4bc3b4'}
            />
          )}

        {footer && (
          <div style={{ width: '100%' }}>
            <img style={{ width: '100%' }} src={footer} />
          </div>
        )}

        {showPoweredBySmile && (
          <div style={{ marginTop: '5px', width: '100%' }}>
            <a
              data-testid="poweredBySmile"
              href={`https://smileweb.net/es?utm_source=smle&utm_medium=pb&utm_campaign=${get(
                context,
                'state.hash'
              )}`}
              target="_blank"
              rel="noreferrer"
            >
              <img className="poweredSmile" src={poweredBySmileSrc} />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Form;
